module.exports = __webpack_public_path__ + "img/Video.dcc3a829.png";